const specialCondition = {
  bindings: {
    index: '<',
    newSpecialCondition: '<',
    viewMode: '<',
    onRemove: '&',
    onSave: '&',
    onEdit: '&',
  },
  templateUrl:
    '/modules/psa/script-form/special-condition/special-condition.html',
  controller: 'SpecialConditionController',
};

angular
  .module('psa.module')
  .component('specialCondition', specialCondition);
